/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValidationError } from './validationError.model';


/**
 * model of response on client errors such as validation errors, authorization errors, etc.
 */
export interface ClientError { 
    message: string;
    /**
     * HTTP status
     */
    status: number;
    /**
     * Time of handling the error
     */
    timestamp: string;
    validationErrors?: Array<ValidationError>;
}

